// extracted by mini-css-extract-plugin
export default {"base":"TextBox_base__CGBIo","error":"TextBox_error__Ws2Xz","errorText":"TextBox_errorText__z97sR"};